/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip
} from '@material-ui/core';
import WarningIcon from '@mui/icons-material/Warning';
import { useNavigate } from 'react-router-dom';
// import { useNavigate, useLocation } from 'react-router-dom';

export default function WarningModal(props) {
  // const timeoutRef = useRef(null);
  const {
    ele,
    type,
    setResult,
    setText,
    setShowRepsDataValue,
    text,
    setSeconds,
    setError,
    setWordCount,
    setComparison,
    result,
    setAllText,
    TimeLimit,
    setCounter,
    setAutomaticSubmit,
    title,
    setSecondflag,
    setErrorValueEach,
    setWpmValue,
    setParagraph,
    setReplay,
    setReplayClick,
    path,
    links
  } = props;
  //   const location = useLocation();
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  //   const [index, setIndex] = useState(0);
  //   const navigate = useNavigate();

  const handleClickOpen = async () => {
    if (type === 'replay' && text.length !== 0) setOpen(true);

    //     if (type === 'Next' || type === 'Prev') {
    //       setOpen(true);
    //     }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const onRepeat = () => {
    // if (timeoutRef.current) {
    //   clearTimeout(timeoutRef.current); // Clear any existing timeout
    // }
    setReplayClick(() => true);
    setCounter(() => Number(TimeLimit ?? 0));
    setShowRepsDataValue(0);
    setResult(false);
    setText('');
    setSeconds(0);
    setSecondflag(false);
    setError(0);
    setWpmValue(0);
    setErrorValueEach(0);
    setWordCount(0);
    handleClose();
    setComparison([]);
    setAllText('');
    setParagraph('');
    setAutomaticSubmit(false);
    setReplay(prev => !prev);
    navigate(path, { state: links });
    if (props.exerciseType === 'Timing' || props.exerciseType === 'TimingKeypadEnter') {
      window.location.reload();
    }
  };
  //   useEffect(() => {
  //     let mounted = true;
  //     if (mounted && nextP) {
  //       let curr = location.pathname;
  //       curr = curr.split('%20').join(' ');
  //       if (nextP && nextP.length > 0) {
  //         let p = nextP.indexOf(curr);
  //         if (p === nextP.length - 1) {
  //           return;
  //         }
  //         setIndex(() => p);
  //       }
  //     }

  //     return () => {
  //       mounted = false;
  //     };
  //   }, [nextP]);

  return (
    <div>
      <Tooltip title={title}>
        <IconButton
          style={{ padding: '0', width: 'fit-content !important', borderRadius: '50%' }}
          onClick={result ? onRepeat : handleClickOpen}>
          {ele}
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            borderRadius: '8px',
            padding: '16px'
          }
        }}>
        <DialogTitle
          style={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '18px'
          }}
          id="warning-dialog-title">
          Warning
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#333',
              fontSize: '16px',
              fontWeight: '500'
            }}
            id="alert-dialog-description">
            <WarningIcon
              style={{ color: '#D32F2F', marginRight: '10px', width: '50px', height: '50px' }}
            />
            By restarting the current activity, you will delete your attempt and your work will not
            be saved. Are you sure you want to restart?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: '2px' }}>
          <Button
            style={{
              color: '#D32F2F',
              border: '1px solid #D32F2F',
              fontWeight: 'bold',
              padding: '4px 30px',
              borderRadius: '4px'
            }}
            variant="outlined"
            onClick={handleClose}>
            CANCEL
          </Button>
          <Button
            style={{
              backgroundColor: '#0D47A1',
              color: 'white',
              fontWeight: 'bold',
              padding: '4px 30px',
              borderRadius: '4px'
            }}
            variant="contained"
            onClick={async () => {
              if (type === 'replay') {
                onRepeat();
              }
            }}
            autoFocus>
            RESTART
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
